"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTrick = exports.TrickOutcome = exports.defaultOptions = exports.isSixtyNine = void 0;
const constants_1 = require("./constants");
const utils_1 = require("./utils");
function isSixtyNine(trick) {
    if (trick.length === 2) {
        const has6 = trick.some((card) => card.value === 6);
        const has9 = trick.some((card) => card.value === 9);
        return has6 && has9;
    }
    return false;
}
exports.isSixtyNine = isSixtyNine;
function isSpecial(trick, { sixtyNine }) {
    if (sixtyNine) {
        return isSixtyNine(trick);
    }
    return false;
}
exports.defaultOptions = {
    shouldSkip: true,
    shouldSwap: true,
    shouldAutoSwap: false,
    cardOrder: constants_1.CARD_ORDER,
    sixtyNine: false,
    wildcards: [{ value: "joker" }],
    twoWinsTrick: false,
    fourOfAKindRevolution: false,
    largerSetBeatsSmallerSet: false
};
var TrickOutcome;
(function (TrickOutcome) {
    TrickOutcome["INVALID"] = "invalid";
    TrickOutcome["START"] = "start";
    TrickOutcome["LOWER"] = "lower";
    TrickOutcome["EQUAL"] = "equal";
    TrickOutcome["HIGHER"] = "higher";
    TrickOutcome["WIN"] = "win";
})(TrickOutcome = exports.TrickOutcome || (exports.TrickOutcome = {}));
function validateTrick(allCardsInPlay, trick, options) {
    const opts = {
        ...exports.defaultOptions,
        ...options
    };
    const inPlay = allCardsInPlay
        ? allCardsInPlay[allCardsInPlay.length - 1]
        : undefined;
    const { cardOrder } = opts;
    if (opts.twoWinsTrick && trick.length === 1 && trick[0].value === 2) {
        return {
            isValid: true,
            winsTrick: true,
            isClearCard: true,
            outcome: TrickOutcome.WIN
        };
    }
    if (opts.fourOfAKindRevolution && allCardsInPlay) {
        const lastRun = (0, utils_1.getLastMatchingTurns)(allCardsInPlay);
        const runLength = lastRun.reduce((count, cards) => {
            return (count += cards.length);
        }, 0);
        const isPure4OfAKind = trick.length === 4 && (0, utils_1.isPureSet)(trick);
        if (isPure4OfAKind ||
            (lastRun.length &&
                lastRun.every((hand) => (0, utils_1.handValuesMatch)(hand, trick)) &&
                runLength + trick.length === 4)) {
            return {
                isValid: true,
                winsTrick: true,
                isRevolution: true,
                outcome: TrickOutcome.WIN
            };
        }
    }
    const trickSpecial = isSpecial(trick, opts);
    const inPlaySpecial = inPlay ? isSpecial(inPlay, opts) : false;
    /**
     * E.g. sixty-nine
     */
    if (trickSpecial) {
        return {
            isValid: true,
            isSpecial: true,
            outcome: inPlaySpecial ? TrickOutcome.EQUAL : TrickOutcome.HIGHER
        };
    }
    /**
     * E.g. sixty-nine
     */
    if (inPlaySpecial) {
        return {
            isValid: false,
            outcome: TrickOutcome.INVALID,
            reason: `Cannot play trick "${(0, utils_1.toValues)(trick)}" on special in-play ${(0, utils_1.toValues)(inPlay)}`
        };
    }
    try {
        const wildcardValues = (0, utils_1.toValues)(opts.wildcards);
        const normalisedTrick = (0, utils_1.collapseHand)(trick, opts.wildcards);
        const isWild = trick.some((c) => wildcardValues.includes(c.value));
        if (!inPlay) {
            return {
                isValid: true,
                outcome: TrickOutcome.START,
                isWild
            };
        }
        const validateNumCards = opts.largerSetBeatsSmallerSet
            ? trick.length >= inPlay.length
            : inPlay.length === trick.length;
        if (!validateNumCards) {
            return {
                isValid: false,
                outcome: TrickOutcome.INVALID,
                reason: `Number of cards in trick "${(0, utils_1.toValues)(trick)}" does not match or beat in-play ${(0, utils_1.toValues)(inPlay)}`
            };
        }
        const normalisedInPlay = (0, utils_1.collapseHand)(inPlay, opts.wildcards);
        if (opts.largerSetBeatsSmallerSet && trick.length > inPlay.length) {
            return {
                isValid: true,
                isWild,
                outcome: TrickOutcome.HIGHER,
                isLargerSet: true,
                reason: `Larger set of ${trick.length} beats in-play set of ${inPlay.length}`
            };
        }
        let inPlayRank = cardOrder.indexOf(normalisedInPlay);
        let trickRank = cardOrder.indexOf(normalisedTrick);
        if (trickRank === -1) {
            throw new Error(`Cannot find card ${trickRank} rank`);
        }
        /**
         * If the "in-play" is wild that means the a round has started
         * with wild, which will be the lowest possible hand and then
         * any card laid on-top will beat it (no miss-a-gos possible)
         */
        const inPlayIsTotallyWild = wildcardValues.includes(normalisedInPlay);
        const isTotallyWild = wildcardValues.includes(normalisedTrick);
        if (inPlayIsTotallyWild) {
            inPlayRank = -1;
            if (isTotallyWild) {
                trickRank = -1;
            }
        }
        const isHigher = trickRank > inPlayRank;
        /**
         * Trick played is only wildcards then it equals
         * the inPlay hand
         */
        const equals = isTotallyWild || trickRank === inPlayRank;
        if (!isHigher && !equals) {
            return {
                isValid: false,
                outcome: TrickOutcome.LOWER,
                reason: `${normalisedTrick} is lower than ${normalisedInPlay}`,
                isWild
            };
        }
        const wildValue = isTotallyWild
            ? normalisedInPlay
            : isWild && !inPlayIsTotallyWild
                ? normalisedTrick
                : undefined;
        return {
            isValid: true,
            outcome: equals ? TrickOutcome.EQUAL : TrickOutcome.HIGHER,
            wildValue,
            isWild
        };
    }
    catch (err) {
        return {
            isValid: false,
            outcome: TrickOutcome.INVALID,
            reason: err instanceof Error ? err.message : "Unknown"
        };
    }
}
exports.validateTrick = validateTrick;
//# sourceMappingURL=rules.js.map